/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

// import { boolean } from "Yup";

/* eslint-disable @typescript-eslint/strict-boolean-expressions */
const InitialValuesForm = {
  companyStepOneForm: {
    tenantTypeId: '',
    name: '',
    featureSetIds: [],
    brokerCompanyId: null,
    brokerPublishIds: null,
    showBrokerOptions: false,
    ticker: '',
    commissionId: '',
    industrySectorId: '',
    taxId: '',
    countryOfIncorporationId: '',
    stateOfIncorporationText: '',
    stateOfIncorporationId: '',
    primaryStockExchangeId: '',
    dateOfIncorporation: '',
    businessDescription: '',
    websiteUrl: '',
    domainNames: [''],
    headQuarterCityText: '',
    headQuarterStateText: '',
    headQuarterCountryId: '',
    headQuarterAddressLine1: '',
    headQuarterAddressLine2: '',
    headQuarterStateId: '',
    headQuarterZipCode: '',
    companyAddressList: [],
    additionalAddress: false,
    isEnabled: true,
    cusip: '',
    sicCode: '',
    isPartBRequired: 'true',
    isPartCRequired: 'true',
    companyTypes: [],
    companyLabelTypes: [],
    useDefaultPsp: true,
    distributableFeatureSetIds: [],
    brandingPackageId: null,
  },
  companyStepTwoForm: {
    ADMIN: {
      email: '',
      phone: '',
      firstName: '',
      middleName: '',
      lastName: '',
      countryCallingCodeId: '',
    },
    // APPROVAL: {
    //   email: '',
    //   phone: '',
    //   firstName: '',
    //   middleName: '',
    //   lastName: '',
    //   countryCallingCodeId: '',
    // },
    vendorDesignationUsers: [
      {
        roleId: '',
        vendorUserIds: [],
      },
    ],
    isEnabled: true,
  },
  udfInitialForm: {
    fieldName: '',
    fieldType: '',
    isMandatory: null,
    moduleId: '',
    orderNumber: null,
    status: null,
  },
  editCompanyProfileForm: {
    name: '',
    ticker: '',
    industrySectorId: '',
    primaryStockExchange: '',
    dateOfIncorporation: '',
    stateOfIncorporationId: '',
    taxId: '',
    businessDescription: '',
    address: '',
    addressLine1: '',
    addressLine2: '',
    cityText: '',
    stateId: '',
    zipCode: '',
    CUSIP: '',
    sicCode: '',
    isEnabled: true,
  },
  addSystemRoleForm: {
    roleName: '',
    description: '',
    isEnabled: true,
    permissions: {},
    fieldLevelPermissions: {},
  },
  departmentForm: {
    name: '',
    description: '',
  },
  jobTitleForm: {
    name: '',
    description: '',
  },
  employeeTypesForm: {
    name: '',
    description: '',
    isTaxEnable: false,
  },
  addSystemUserForm: {
    email: '',
    firstName: '',
    middleName: '',
    lastName: '',
    customerTitleId: null,
    employeeId: '',
    customerDepartmentId: null,
    customerRoleId: null,
    phone: '',
    countryCallingCodeId: '',
    phoneIsOtherCountry: false,
    permissions: [],
    customerSuccessConfiguration: {
      isAllowedToSwitchToAllMappedCompanies: false,
      customerRoleIds: [],
      companyIds: [],
    },
  },
  tableParams: {
    filter: '',
    sorting: '',
    skipCount: 0,
    maxResultCount: 10,
  },

  rsuFilter: {
    fromDate: null,
    toDate: null,
    approvalStatusId: null,
  },
  retirementEligibility: {
    id: null,
    eligibilityCriteriaId: '',
    ageYear: null,
    ageMonth: null,
    tenureCompletedYear: null,
    tenureCompletedMonth: null,
  },
  participantBroadcastMessage: {
    title: '',
    messageTemplateId: '',
    startDate: '',
    endDate: '',
    addToTemplate: false,
  },
  optionAwards: {
    employee: [
      {
        employeeId: '',
        participantId: '',
        participantName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        planId: '',
        planName: '',
        planTypeId: '',
        planType: '',
        grantId: '',
        grantName: '',
        grantPrice: '',
        quantity: '',
        marketValueAtGrant: '',
        grantDate: null,
        vestingStartDate: null,
        excercisePrice: '',
        remarks: '',
        vestingSchedule: '',
        vestingTemplateId: '',
        grantReason: '',
        methodType: '',
        asOfDate: null,
        residualDate: null,
        targetOutStanding: 0,
        targetCancelled: null,
        isEarlyExerciseEnabled: false,
        adjustmentReason: '',
        poolId: '',
        isOffline: false,
        isAccepted: null,
        acceptanceDate: null,
        awardAcceptanceDocumentInput: {
          acceptanceDocument: [],
        },
        acceptanceDocumentList: [],
        cancelShareTypeId: null,
        optionExpirationInMonth: null,
        optionExpirationInDay: null,
      },
    ],
  },

  rsuAwards: {
    employee: [
      {
        employeeId: '',
        participantId: '',
        participantName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        grantId: '',
        grantName: '',
        grantDate: null,
        vestingStartDate: null,
        quantity: '',
        grantPrice: '',
        marketValueAtGrant: '',
        planId: '',
        planName: '',
        planTypeId: '',
        planType: '',
        remarks: '',
        vestingSchedule: '',
        vestingTemplateId: '',
        grantReason: '',
        methodType: '',
        poolId: '',
        asOfDate: null,
        residualDate: null,
        targetOutStanding: 0,
        targetCancelled: null,
        adjustmentReason: '',
        isOffline: false,
        isAccepted: null,
        acceptanceDate: null,
        awardAcceptanceDocumentInput: {
          acceptanceDocument: [],
        },
        acceptanceDocumentList: [],
        cancelShareTypeId: null,
        isUnvestedAcquisition: null,
      },
    ],
  },

  tradePreClearance: {
    id: '',
    optionType: '',
    participantDashboardText: 'Hello',
    isIndividual: false,
    isGroup: false,
    selectAll: false,
    participantIds: [],
    tradePreClearanceGroups: [
      {
        departmentId: null,
        employeeTypeId: null,
        jobTitleIds: [],
        groupData: false,
        isRule144: false,
        isSection16: false,
      },
    ],
  },

  tradingBlackoutConfig: {
    id: null,
    blackoutTitle: '',
    message: '',
    startDate: null,
    endDate: null,
    startTime: null, // NEW: Store the time portion (e.g., "14:30")
    endTime: null, // NEW: Store the end time
    startImmediately: false, // NEW: Checkbox state for immediate start
    endImmediately: false, // NEW: Checkbox state for immediate end
    lastModifiedDate: null, // NEW: Track last modification timestamp
    blackoutEligibilityId: null,
    blackoutGroups: [
      {
        id: null,
        groupData: false,
        customerDepartmentId: null,
        employeeTypeId: null,
        blackOutJobTitles: [],
      },
    ],
  },

  participants: {
    participant: [
      {
        payrollId: null,
        employeeId: null,
        firstName: '',
        middleName: '',
        lastName: '',
        contactNumberCountryCode: '',
        isOtherCountryPhone: false,
        ssn: '',
        titleId: null,
        divisionId: null,
        email: '',
        costCenter: '',
        dateOfBirth: '',
        hireDate: '',
        countryId: null,
        workNumber: '',
        workNumberCountryCodeId: null,
        employeeTypeId: null,
        employmentCountryId: null,
        employmentStateId: null,
        employmentCityText: '',
        employmentZipCode: '',
        employmentAddressLine1: '',
        employmentAddressLine2: '',
        residentStatusId: null,
        residentStatusName: '',
        isOtherCountry: false,
        participantOtherCountry: false,
      },
    ],
    terminateParticipant: {
      employeeId: '',
      participantId: '',
      terminationTypeId: '',
      cancelShareTypeId: '',
      awardAdjustmentMethodId: '',
      optionExpirationDays: '',
      awardStatusId: '',
      terminationDate: '',
      awardEffectiveDate: '',
      effectiveDate: '',
      terminationReason: 'Termination',
      awardDetails: [],
      // awardDetails: [
      //   {
      //     participantId: '',
      //     rsuAwardId: '',
      //     optionAwardId: '',
      //     awardNumber: '',
      //     planTypeCategoryId: '',
      //     planTypeCategory: '',
      //     outstandingUnits: 0,
      //     applicableUnits: null,
      //     awardEffectiveDate: '',
      //     awardStatusId: '',
      //     awardStatusName: '',
      //   },
      // ],

      // terminationTypeId: '',
      // terminationDate: '',
      // awardStatusId: '',
      // awardEffectiveDate: '',
      // remarks: '',
      // individualAwards: false,
      // awardDetails: [
      //   {
      //     awardEffectiveDate: '',
      //   },
      // ],
    },
  },

  remarksInitialValues: {
    remarks: '',
    id: '',
  },

  approvalConfig: {
    customerUserDtos: [],
  },
  planManagementModel: {
    name: '',
    planExpiryDate: '',
    // numberOfSharesAuthorized: '',
    // numberOfSharesUnAvailable: '',
    // numberOfSharesAvailable: '',
    // numberOfSharesIssued: '',
    poolId: '',
    description: '',
    allowEditPlanRelatedDocuments: false,
    planTypeCategoryIds: [],
    planDocument: [
      // {
      //   fileName: '',
      //   document: '',
      // },
    ],
    eligibleShareClass: '',
    boardApprovalDate: '',
    shareHolderApprovalDate: '',
    planTerm: '',
    evergreenPlan: '',
    evergreenCriteria: '',
    deathExpirationOption: '',
    disablityExpirationOption: '',
    retirementExpirationOption: '',
    volutaryTerminationOption: '',
    involutaryTerminationOption: '',
    withACause: '',
    planNameList: [],
    planEffectiveDate: '',
    optionExpirationDate: '',
    planGrantDocumentsNameList: [],
    planGrantDocuments: [
      // {
      //   grantDocumentName: '',
      //   description: '',
      //   document: '',
      //   grantDocumentType: null,
      //   grantTermsAndConditionText: '',
      // },
    ],
    terminationRules: [
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: '',
        expirationInMonths: '',
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: '',
        expirationInMonths: '',
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: '',
        expirationInMonths: '',
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: '',
        expirationInMonths: '',
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: '',
        expirationInMonths: '',
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: '',
        expirationInMonths: '',
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
    ],
  },
  terminationRulesModal: {
    terminationRules: [
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: null,
        expirationInMonths: null,
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: null,
        expirationInMonths: null,
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: null,
        expirationInMonths: null,
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: null,
        expirationInMonths: null,
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: null,
        expirationInMonths: null,
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
      {
        // id: null,
        // tenantId: null,
        participantTerminationTypeId: null,
        // terminationRuleSetId: null,
        expirationInDays: null,
        expirationInMonths: null,
        awardAdjustmentMethodId: '',
        cancelShareTypeId: '',
      },
    ],
  },
  vestingTemplate: {
    name: '',
    summary: '',
    vestingTypeId: null,
    lengthInMonths: null,
    amountOneInPercentage: 0 || null,
    vestsAfterInMonths: null,
    endOfTheMonthTypeId: null,
    amountTwoInPercentage: 0 || null,
    vestsInMonths: 0 || null,
    intervalInMonths: 0 || null,
    roundingTypeId: null,
    loadingTypeId: null,
    periodStartDate: '',
    specificVestingInstruction: '',
    // planTypeCategoryId: '',
  },
  previewVestingTemplate: {
    vestStartDate: '',
    awardShares: 0 || null,
    vestingTemplateId: '',
  },
  grantManagement: {
    sn: null,
    importType: '',
    grantName: '',
    planTypeName: '',
    approvedDate: '',
    vestingTemplateName: '',
    acceptanceMethod: '',
    acceptanceMethodId: '',
    performanceRuleName: '',
    approvalRequired: false,
    grantAgreementDocumentName: '',
    grantNoticeDocumentName: '',
    agreementStatement: '',
    agreementStatementStatusName: '',
    termsAndConditionDocumentName: '',
    termsAndConditionTextName: '',
    planId: null,
    id: null,
    settlementTypeId: '',
    planGrantDocuments: [
      /*  {
        grantDocumentName: '',
        description: '',
        fileExtension: '',
        document: '',
        grantDocumentType: 0,
        grantTermsAndConditionText: '',
      }, */
    ],
  },
  // grantManagement: {
  //   planTypeName: '',
  //   grantName: '',
  //   vestingScheduleId: '',
  //   performanceRuleId: '',
  //   vestingScheduleName: '',
  //   documentNameList: [],
  //   grantDocument: [],
  //   termsAndConditionsDocumentContent: '',
  //   approvedDate: '',
  //   isActive: '',
  //   termsAndConditionsDocumentName: [],
  //   termsAndConditionsDocument: [],
  //   termsAndConditionsAgreementStatement: '',
  //   name: '' || null || undefined,
  //   summary: '' || null,
  //   vestingTypeId: '',
  //   lengthInMonths: 0,
  //   amountOneInPercentage: 0 || null,
  //   vestsAfterInMonths: null,
  //   amountTwoInPercentage: 0 || null,
  //   vestsInMonths: 0 || null,
  //   intervalInMonths: 0 || null,
  //   roundingTypeId: null,
  // },
  awardSettlementConfig: {
    RSU: {
      sellAll: '',
      sellToCover: '',
      cashExercise: '',
    },
    ESOP: {
      sellAll: '',
      sellToCover: '',
      cashExercise: '',
    },
  },
  termAndCondition: {
    id: '',
    name: '',
    documentContent: '',
    isActive: '',
    documentList: [],
    document: [],
    pageId: '',
    agreementStatement: '',
  },
  Headquarter: {
    addressLine1: '',
    addressLine2: '',
    countryId: '',
    stateId: '',
    cityId: '',
    state: '',
    city: '',
    zipCode: '',
  },
  changePassword: {
    currentPassword: '',
    newPassword: '',
    repeatPassword: '',
  },

  taxPeriod: {
    name: '',
    effectiveFrom: '',
    effectiveTill: '',
  },

  taxSetup: {
    name: '',
    jurisdictionLevelId: '',
    taxPeriodId: '',
    taxCode: '',
    equityCompensationLevelId: '',
    equityCompensationLevelName: '',
    countryId: null,
    stateId: null,
    stateText: '',
    cityId: null,
    participantId: null,
    planId: null,
    grantId: null,
    awardId: null,
    transactionId: null,
    incomeYtdTypeId: '',
    userDefinedCriteria: {
      LogicalOperatorType: 'And',
      Conditions: [
        {
          Hash: null,
          EqualityOperatorType: null,
          Field: null,
          Value: null,
          Name: null,
          SubCriteria: {
            LogicalOperatorType: null,
            Conditions: [
              {
                Hash: null,
                EqualityOperatorType: null,
                Field: null,
                Value: '',
                Name: null,
                SubCriteria: null,
              },
            ],
          },
        },
      ],
    },
    taxBrackets: [
      {
        taxRate: '',
        lowerLimit: '',
        upperLimit: '',
      },
    ],
    // userDefinedGroup: [
    //   {
    //     condition: '',
    //     userDefinedRules: [
    //       {
    //         rule: '',
    //         subRule: '',
    //       },
    //     ],
    //   },
    // ],
  },
  taxOverride: {
    id: '',
    name: '',
    jurisdictionLevelId: '',
    taxPeriodId: '',
    taxCode: '',
    equityCompensationLevelId: '',
    countryId: null,
    stateId: null,
    stateText: '',
    cityId: null,
    participantId: null,
    planId: null,
    grantId: null,
    transactionId: null,

    taxBrackets: [
      {
        taxRate: '',
        lowerLimit: '',
        upperLimit: '',
      },
    ],
  },
  reportSaveAs: {
    reportName: '',
  },
  renameCustomizeReport: {
    reportName: '',
  },
  releaseForm: {
    name: '',
    expectedReleaseDate: '',
    bulkExecutionName: '',
    ignoreBrokerage: false,
    description: '',
  },
  transferAndAllocateForm: {
    name: '',
    description: '',
    isDrs2BrokerTransferAllocate: false,
  },
  drsRegistrationForm: {
    name: '',
    description: '',
  },

  transactionTaxDetails: {
    details: [
      {
        taxName: '',
        taxRate: '',
        value: '',
      },
    ],
  },
  updateTax: {
    id: null,
    transactionId: null,
    taxDetails: [
      {
        id: null,
        taxName: '',
        taxRate: null,
        taxAmount: null,
        isDeleted: false,
      },
    ],
    taxDetailsDeleted: [],
  },
  performanceRule: {
    ruleName: '',
    ruleTypeId: '',
    isAvailable: false,
    evaluationPeriodStartDate: '',
    evaluationPeriodEndDate: '',
    minimumPercentage: null,
    maximumPercentage: null,
    ruleDescription: '',
    ruleSummary: '',
    showRuleDisplayToParticipant: false,
    showPerformanceTrackingToParticipant: false,
    estimatePerformanceTrackings: [],
    performanceEvaluation: null,
  },
  // grantDocumentModel: {
  //   grantDocumentName: '',
  //   description: '',
  //   documentNameList: [],
  //   document: [],
  //   grantTermsAndConditionText: '',
  // },
  grantDocumentModel: {
    grantDocumentName: '',
    description: '',
    grantDocumentType: 0,
    grantTermsAndConditionText: '',
    planGrantDocumentDetails: [
      {
        effectiveDate: '',
        isActive: true,
        fileContentName: '',
        documentNameList: [],
        document: [],
        fileExtension: '',
      },
    ],
  },

  grantTermAndConditionModel: {
    termsAndConditionsDocumentContent: '',
    isActive: '',
    termsAndConditionsDocumentName: [],
    termsAndConditionsDocument: [],
    termsAndConditionsAgreementStatement: '',
  },
  offeringPeriod: {
    name: '',
    offeringPeriodStartDate: '',
    offeringPeriodEndDate: '',
    fmvAtStart: null,
    startPurchasePrice: 0,
    discountPercent: null,
    priceRule: '' || null,
    enrollmentWindowMaxChanges: null,
    changeWindowMaxUpChanges: null,
    changeWindowMaxDownChanges: null,
    changeEndDaysPriorToPurchaseDate: null,
    enrollStartDaysPriorToPurchasePeriod: null,
    enrollDays: null,
    rolloverEnrollment: false,
    residualCashDisposition: '' || null,
    nextOfferingPeriodId: '' || null,
    allowParticipantToSuspendWithPurchase: false,
    allowParticipantToSuspendWithoutPurchase: false,
    allowParticipantToWithdrawWithPurchase: false,
    allowParticipantToWithdrawWithoutPurchase: false,
    offeringPeriodType: '' || null,
    lookback: false,
    planId: '',
    purchasePeriods: [
      // {
      //   purchasePeriodId: '' || null,
      //   purchasePeriodIndex: 0,
      //   periodStartDate: '',
      //   periodEndDate: '',
      //   purchaseDate: '',
      //   purchasePrice: null,
      //   enrollmentWindowStartDate: '',
      //   enrollmentWindowEndDate: '',
      //   changeWindowStartDate: '',
      //   changeWindowEndDate: '',
      // },
    ],
  },
  purchasePeriodDto: {
    numberOfPeriod: null,
    purchasePeriodDetails: [
      {
        purchasePeriodId: '' || null,
        purchasePeriodIndex: 0,
        periodStartDate: '',
        periodEndDate: '',
        purchaseDate: '',
        purchasePrice: null,
        enrollmentWindowStartDate: '',
        enrollmentWindowEndDate: '',
        changeWindowStartDate: '',
        changeWindowEndDate: '',
      },
    ],
  },

  rolePublishModal: {
    destinationCompanyId: [],
    sourceRoleId: null,
  },
  roleMappingModal: {
    destinationRoleId: null,
    items: [],
  },
  companyMapping: {
    sourceCompanyId: null,
    destinationCompanyId: null,
  },
  switchSandboxModal: {
    name: '',
    sandboxType: null,
    fromTenantId: null,
    description: '',
  },
  pushToProductionModal: {
    sandboxTenantId: null,
    remarks: null,
  },
  featureSetModal: {
    name: '',
    description: '',
    permissions: {},
    fieldLevelPermissions: {},
  },
  Schema: {
    identifierName: '',
    description: '',
    schemaSection: '',
    uiSchemaType: '',
    isEnabled: true,
    uiSchemaContent: `(function() {
    if (window.UISchemaFactory) {
        delete window.UISchemaFactory;
    }
    const rem = (size) => {
        const remSize = size / 10;
        return $ {
            remSize
        }
        rem;
    };
    class UISchemaFactory {
        constructor() {}
        createUISchema(options) {
            const {
                jsonSchema,
                setJsonSchema,
                uiSchema,
                setUiSchema,
                widgets,
                templates,
                api,
                formData,
                setFormData,
                utils,
                ...rest
            } = options;
            return {};
        }
    }
    window.UISchemaFactory = UISchemaFactory;
})();`,
    jsonSchemaContent: '',
  },
  externalBankAccount: {
    routingTypeId: null,
    routingNumber: '',
    accountTypeId: null,
    accountName: '',
    accountNickName: '',
    accountNumber: '',
    institutionName: '',
  },
  emailTemplate: {
    message: '',
  },
  grantAcceptanceTemplate: {
    templateName: '',
    statusId: null,
    content: '',
    effectiveDate: '',
  },
  commission: {
    name: '',
    brokerCompanyId: null,
    description: '',
    baseRate: '',
    maximumAmount: '',
    rateBrackets: [
      {
        rate: '',
        lowerShareLimit: '',
        upperBracketLimit: '',
        upperLimit: '',
      },
    ],
  },
  fee: {
    effectiveDate: '',
    rate: '',
  },
  jobSchedule: {
    name: '',
    description: '',
    recurrenceTypeId: '',
    recurrenceStartDateTime: '',
    recurrenceStartDate: '',
    recurrenceStartTime: '',
    taskTypeId: '',
    recurrenceInstructionsJson: {
      cronExpression: '',
      timeZone: '',
      // customRecurrenceInstructionsJson: {
      //   repeatEvery: 1,
      //   repeatUnit: 'week',
      //   repeatOnDays: ['MON'],
      //   endType: 'never',
      //   endOn: '',
      //   occurrencesLimit: 10,
      // },
      customRecurrenceInstructionsJson: {
        repeatEvery: null,
        repeatUnit: null,
        repeatOnDays: [],
        endType: null,
        endOn: null,
        occurrencesLimit: null,
      },
    } as Record<string, any>,
    taskInstruction: {
      taskDetailId: '',
      taskExecutionDto: '',
      responseDetails: '',
    },
  },
  customRecurrenceInstructionsJson: {
    repeatEvery: 1,
    repeatUnit: 'week',
    repeatOnDays: ['MON'],
    endType: 'never',
    endOn: '',
    occurrencesLimit: 10,
  },
  awardAgreement: {
    file: '',
    zipFile: '',
  },
  sandboxConfig: {
    maximumSandboxLimit: 0,
    currentSandboxCount: 0,
  },
  fixConfiguration: {
    brokerCompanyId: '',
    brokerSessionKey: null,
    isFixEngineEnabled: '',
  },
  fmvConfiguration: {
    createGrantDateFmvDtos: [],
    createUpdateTransactionDateFmvDtos: [],
  },
  ssoConfiguration: {
    companyId: '',
    providerName: '',
    providerCode: '',
    clientId: '',
    clientSecret: '',
    authority: '',
    configIdentifier: '',
    redirectUri: '',
    isEnabled: true,
    providerType: '',
    providerSigningCertificate: '',
    displayName: '',
    loginInitiateUrl: '',
    claimType: '',
    userMappingClaim: '',
  },
  updateSigningCertificate: {
    providerSigningCertificate: '',
  },
  taskExecutionDto: {
    awardTypeId: '',
    grantIds: [],
    settlementTypeIds: [],
    configuration: [],
    timeInterval: null,
    taskDetailsName: '',
  },
  sharePoolManagement: {
    id: '',
    poolName: '',
    numberOfSharesAuthorised: '',
    numberOfSharesAvailable: '',
    numberOfSharesUnAvailable: '',
    eligibleShareClass: '',
    hasExternalPoolRefrence: false,
    description: '',
    externalPoolName: '',
    externalPoolReferenceId: '',
  },
  transactionConfig: {
    priceThreshold: '',
    transactionAcquisitionTypeId: null,
    intendedShareRegistrationTypeId: null,
  },
  isoConfiguration: {
    sortTypeId: null,
  },
  transferAgentSetting: {
    clientId: '',
    clientSecret: '',
    transferAgentId: '',
    description: '',
    isEnabled: false,
  },
};

export default InitialValuesForm;
